var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserIneligible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#E41830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1369 6.86279L7.84277 42.1569",
    stroke: "#EBF7F6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0912 38.6031V35.5802C37.0912 33.9767 36.4542 32.439 35.3204 31.3052C34.1867 30.1714 32.6489 29.5344 31.0455 29.5344H18.954C17.3505 29.5344 15.8128 30.1714 14.679 31.3052C13.5452 32.439 12.9082 33.9767 12.9082 35.5802V38.6031",
    stroke: "#EBF7F6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 23.4887C28.3388 23.4887 31.0456 20.7819 31.0456 17.443C31.0456 14.104 28.3388 11.3972 24.9999 11.3972C21.6609 11.3972 18.9541 14.104 18.9541 17.443C18.9541 20.7819 21.6609 23.4887 24.9999 23.4887Z",
    stroke: "#EBF7F6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIneligible);
export default __webpack_public_path__ + "static/media/user-ineligible.59e25f2da4688c4cc80222557daf5902.svg";
export { ForwardRef as ReactComponent };